import { fg } from '@atlaskit/platform-feature-flags';
import { isAIFCAction } from '@atlassian/conversation-assistant-action-helpers/utils';
import {
	isStoreAssistant,
	type StoreChatItem,
} from '@atlassian/conversation-assistant-store/controllers/chat/types';

export const hasStreamingAction = (message?: StoreChatItem): boolean =>
	Boolean(
		message &&
		isStoreAssistant(message) &&
		message.content.message.message.actions?.some(
			(action: { status?: string; key: string }) =>
				action.status?.toLowerCase() === 'streaming' && isAIFCAction(action),
		) &&
		fg('aifc_trace_text_updates'),
	);
